import styled from '@emotion/styled'

import theme from 'styles/theme'

export const SnackbarWrapper = styled.div<{ isError: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: fixed;
  left: 20px;
  bottom: 50px;
  min-height: 50px;
  z-index: 9999991;
  background: ${({ isError }) => (isError ? theme.token.var('colors.red.a150') : theme.token.var('colors.green.a200'))};
  border-radius: ${theme.token.var('borderRadius.small')};
  color: ${theme.token.var('colors.white')};

  @media (min-width: ${theme.token('breakpoints.md')}) {
    left: 120px;
  }
`
